/* eslint max-len: 0 */ import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
// font-awesome "check"
export default function SuccessIcon() {
    return /*#__PURE__*/ _jsx("svg", {
        width: "20",
        height: "16",
        viewBox: "0 0 1792 1792",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z",
            fill: "#fff"
        })
    });
}
